const PrivacyPolicy = () => {
  return (
    <main className="min-h-screen py-20 bg-dark-black">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Privacy Policy
          </h1>
          <p className="text-gray-400 mb-8">
            Last updated: 02.12.2025
          </p>
          
          <div className="prose prose-invert max-w-none space-y-6 text-gray-300 leading-relaxed">
            <p className="text-xl text-gray-200">
              At Empire Wager, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website empire-wagers.com. Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Information We Collect</h2>
            <p>
              We collect information that you provide directly to us when you use our website. This includes information you provide when you fill out contact forms, subscribe to newsletters, or communicate with us. The types of information we may collect include your name, email address, phone number, and any other information you choose to provide.
            </p>
            <p>
              We automatically collect certain information when you visit our website, including your IP address, browser type, operating system, access times, and the pages you have viewed directly before and after accessing the site. This information helps us understand how visitors use our website and improve our services.
            </p>
            <p>
              We may also collect information through cookies and similar tracking technologies. Cookies are small data files stored on your device that help us improve your experience, analyze site usage, and assist in our marketing efforts. You can control cookie settings through your browser preferences.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">How We Use Your Information</h2>
            <p>
              We use the information we collect to provide, maintain, and improve our services. This includes responding to your inquiries, sending you newsletters or promotional communications (if you've opted in), analyzing how our website is used, and personalizing your experience.
            </p>
            <p>
              We may use your information to communicate with you about our services, respond to your comments and questions, and provide customer support. We also use information to detect, prevent, and address technical issues and security threats.
            </p>
            <p>
              If you have opted in to receive marketing communications, we may use your information to send you promotional materials about our services or third-party offers that may interest you. You can opt out of these communications at any time by following the unsubscribe instructions in the emails we send or by contacting us directly.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Information Sharing and Disclosure</h2>
            <p>
              We do not sell, trade, or rent your personal information to third parties. However, we may share your information in certain circumstances, including with service providers who perform services on our behalf, such as website hosting, data analysis, email delivery, and customer service.
            </p>
            <p>
              We may disclose your information if required to do so by law or in response to valid requests by public authorities. We may also share information to protect our rights, privacy, safety, or property, or that of our users or others, and to enforce our terms and conditions.
            </p>
            <p>
              In the event of a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction. We will notify you of any such change in ownership or control of your personal information.
            </p>
            <p>
              We may share aggregated or anonymized information that does not identify you personally. This information may be used for research, analytics, or other purposes without restriction.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Third-Party Links</h2>
            <p>
              Our website contains links to third-party websites, including online casinos and gambling operators. When you click on these links, you will be directed to third-party websites that are not operated by us. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
            </p>
            <p>
              We strongly advise you to review the privacy policy of every site you visit. We are not responsible for the privacy practices or content of external websites, even if they are linked from our site.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
            </p>
            <p>
              We use industry-standard security technologies and procedures to help protect your personal information. This includes encryption, secure servers, and regular security assessments. However, you should be aware that no security measures are perfect or impenetrable.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Your Rights and Choices</h2>
            <p>
              You have certain rights regarding your personal information. You may request access to, correction of, or deletion of your personal information. You may also object to or restrict certain processing of your information, or request data portability.
            </p>
            <p>
              You can opt out of receiving promotional communications from us by following the unsubscribe instructions in our emails or by contacting us directly. Even if you opt out, we may still send you non-promotional communications, such as those about your account or our ongoing business relations.
            </p>
            <p>
              You can control cookies through your browser settings. Most browsers allow you to refuse cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our website.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Data Retention</h2>
            <p>
              We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. When we no longer need your information, we will securely delete or anonymize it.
            </p>
            <p>
              The retention period may vary depending on the type of information and the purpose for which it was collected. For example, we may retain contact form submissions for a reasonable period to respond to inquiries, while analytics data may be retained longer for statistical purposes.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Children's Privacy</h2>
            <p>
              Our website is not intended for individuals under the age of 18. We do not knowingly collect personal information from children. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately so we can delete such information.
            </p>
            <p>
              If we become aware that we have collected personal information from a child without verification of parental consent, we will take steps to remove that information from our servers.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">International Data Transfers</h2>
            <p>
              Your information may be transferred to and processed in countries other than your country of residence. These countries may have data protection laws that differ from those in your country. We take steps to ensure that your information receives an adequate level of protection in the jurisdictions in which we process it.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify you of any material changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>
            <p>
              You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page. Your continued use of our website after any changes constitutes your acceptance of the new Privacy Policy.
            </p>

            <h2 className="text-3xl font-bold text-white mt-12 mb-6">Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or our privacy practices, please contact us:
            </p>
            <p>
              <strong>Email:</strong> info@empire-wagers.com<br />
              <strong>Phone:</strong> +44 5511 778 569<br />
              <strong>Address:</strong> London, United Kingdom
            </p>
            <p>
              We will respond to your inquiry as soon as possible and within the timeframes required by applicable law.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PrivacyPolicy;

